// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3YiEF","info":"Note_info__tQaCD","note":"Note_note__2VUHH","actions":"Note_actions__N2yCW"};